import { RolesList } from "../../components/AdminLayout/RolesList";
import AdminLayout from "../../components/AdminLayout";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export function Roles() {
  const { t } = useTranslation();

  return (
    <AdminLayout>
      <div className="title">
        <h1>{t("roles&permission")}</h1>
        <div className="filtersandbutton">
          <NavLink to="/Add_Role" className="adduser">
            Add New Role
          </NavLink>
        </div>
      </div>

      <RolesList />
    </AdminLayout>
  );
}
